module.exports = __webpack_public_path__ + "img/企业管理.64a4de76.png";